import React, { useState } from "react";
import { getUnitOptions } from "../utils/utils";
import SpecManagerSelect from "../shared/SpecManagerSelect";
import SpecsQualitative from "../shared/SpecsQualitative";
import SpecsQuantitative from "../shared/SpecsQuantitative";
import SpecsRange from "../shared/SpecsRange";
import MrlCountryList from "../shared/MrlCountryList";
import rangeIcon from "../../../../assets/images/product/RangeIcon.svg";
import quantitativeIcon from "../../../../assets/images/product/QuantitativeIcon.svg";
import qualitativeIcon from "../../../../assets/images/product/QualitativeIcon.svg";
import "./TestSpecForm.css";

const TEST_TYPE_OPTIONS = [
  { value: "range", label: "Range", iconSrc: rangeIcon },
  { value: "quantitative", label: "Quantitative", iconSrc: quantitativeIcon },
  { value: "qualitative", label: "Qualitative", iconSrc: qualitativeIcon },
];

export default function TestSpecForm({
  specRows,
  unitOptions,
  onSpecRowsChange,
  customOnlyNoStandard = false,
}) {
  const [newQualitativeRowIndex, setNewQualitativeRowIndex] = useState(null);
  const resolvedUnitOptions = getUnitOptions(unitOptions);

  const updateSpecRow = (rowIndex, fieldName, fieldValue) => {
    const updatedRows = specRows.map((row) => ({ ...row }));
    if (fieldName === "test_type") {
      if (updatedRows[rowIndex].test_type !== fieldValue) {
        updatedRows[rowIndex].test_type = fieldValue;
        updatedRows[rowIndex].specs = ["", "", ""];
        if (fieldValue === "qualitative") {
          setNewQualitativeRowIndex(rowIndex);
        }
      }
    } else if (fieldName === "specs") {
      updatedRows[rowIndex].specs = fieldValue;
    } else if (fieldName === "countries_lst") {
      updatedRows.forEach((row, index) => {
        if (row.countries_lst) {
          updatedRows[index] = {
            ...row,
            test_type: "",
            specs: ["", "", ""],
            countries_lst: fieldValue,
          };
        }
      });
    }
    onSpecRowsChange(updatedRows);
  };

  return (
    <div className="TestSpecForm_Container">
      {specRows.map((specRow, rowIndex) => {
        const hasMrl = Array.isArray(specRow.countries_lst)
          && specRow.countries_lst.length > 0;
        const isQualitative = specRow.test_type === "qualitative";
        const isRange = specRow.test_type === "range";
        const isQuantitative = specRow.test_type === "quantitative";
        const showNoTypePlaceholder = !hasMrl && !isQualitative && !isRange && !isQuantitative;

        return (
          <div key={`${specRow.test}-${rowIndex}`} className="TestSpecForm_Card">
            <div className="TestSpecForm_CardHeader">
              <div className="TestSpecForm_CardHeaderStripe" />
              <div className="TestSpecForm_CardHeaderTitle">Test Standard</div>
            </div>

            <div className="TestSpecForm_CardBody">
              <div className="TestSpecForm_Row">
                <div className="TestSpecForm_RowLabel">Test Type</div>
                <div className="TestSpecForm_DropdownBox">
                  {hasMrl && (
                    <div className="TestSpecForm_MrlType">MRL</div>
                  )}

                  {!hasMrl && (
                    <SpecManagerSelect
                      variant="borderless"
                      placeholder="Choose Test Type"
                      options={TEST_TYPE_OPTIONS}
                      selectedValue={specRow.test_type || undefined}
                      onSelect={(selected) => updateSpecRow(rowIndex, "test_type", selected)}
                    />
                  )}
                </div>
              </div>

              <div className="TestSpecForm_Row">
                <div className="TestSpecForm_SpecRow">
                  <div className="TestSpecForm_SpecLabel">Spec</div>
                  <div className="TestSpecForm_SpecDetails">
                    {hasMrl && (
                      <MrlCountryList
                        countriesData={specRow.countries_lst}
                        editMode
                        onChange={(countriesList) => updateSpecRow(rowIndex, "countries_lst", countriesList)}
                      />
                    )}

                    {!hasMrl && (
                      <>
                        {(isQualitative || isRange || isQuantitative) && (
                          <div className="TestSpecForm_SpecFieldBox">
                            {isQualitative && (
                              <SpecsQualitative
                                specValues={specRow.specs}
                                unitOptions={resolvedUnitOptions}
                                isNewQualitative={newQualitativeRowIndex === rowIndex}
                                onChange={(values) => updateSpecRow(rowIndex, "specs", values)}
                              />
                            )}
                            {isRange && (
                              <SpecsRange
                                specValues={specRow.specs}
                                unitOptions={resolvedUnitOptions}
                                onChange={(values) => updateSpecRow(rowIndex, "specs", values)}
                              />
                            )}
                            {isQuantitative && (
                              <SpecsQuantitative
                                specValues={specRow.specs}
                                unitOptions={resolvedUnitOptions}
                                onChange={(values) => updateSpecRow(rowIndex, "specs", values)}
                              />
                            )}
                          </div>
                        )}
                        {showNoTypePlaceholder && (
                          <div className="TestSpecForm_NoType">
                            {customOnlyNoStandard
                              && "No standard spec is configured. Custom limits are shown on each product in the list."}
                            {!customOnlyNoStandard
                              && "Please select test type to view the specs"}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
